import { Player } from "@repo/shared/types";

import axios from "../../privateApi";

export type RewardType =
  | "pack"
  | "item"
  | "playerpick"
  | "player"
  | "cosmetic-evo"
  | "event_token_2";

export type SBCRewardType = {
  type: RewardType;
  resourceId?: number;
  shortName?: string;
  name?: string;
  description?: string;
  shortDescription?: string;
  packImageURL?: string;
  rewardImgURL?: string;
  untradeable: boolean;
  metaRating?: {
    metarating: number;
    playerRoleId: number;
  };
  player?: Player;
  // reward?: any;
};

export type RepeatabilityMode = "NON_REPEATABLE" | "UNLIMITED" | "REFRESH";
type BackendSbcSet = {
  active: boolean;
  categoryId: number;
  categoryName?: string;
  description: string;
  downVotes: number;
  endTime: number;
  id: number;
  imageURL: string;
  isNew: boolean;
  isFavorite: boolean;
  isHidden: boolean;
  hasRefreshed: boolean;
  name: string;
  slug?: string;
  pcPrice: number;
  psPrice: number;
  repeatable: boolean;
  rewards: SBCRewardType[];
  sbcsCount: number;
  solved: boolean;
  solvedCount: number;
  solvedsbcs: any[];
  startTime: number;
  upVotes: number;
  wasDownvoted: boolean;
  wasUpvoted: boolean;
  repeatabilityMode: RepeatabilityMode;
  remainingCost: number | null;
  refreshInterval?: number;
  repeats?: number;
  message?: string;
  unsolvable?: boolean;
  kind?: "NORMAL" | "STREAMLINE";
  pointsRequired?: number;
  trendingScore?: number;
};

export const getSbcSets = async () => {
  try {
    const res = await axios.get<BackendSbcSet[]>("/sbc-sets?page=1&limit=20");
    const sbcSets = res.data.map((sbcSet) => {
      const reward = sbcSet.rewards && sbcSet.rewards[0];

      return {
        ...sbcSet,
        reward,
        message: sbcSet.message,
        repeats: sbcSet.repeats || 0,
        unsolvable: sbcSet.unsolvable,
      };
    });
    return sbcSets;
  } catch {
    return [];
  }
};
